import React, { useEffect } from "react";
import { Toaster, useToasterStore } from "react-hot-toast";
import Routes from "./Routes";
import { initGlobalErrorHandlers } from "./services/errorService";

const TOAST_STYLES = `
@keyframes toastSlideIn {
  from { transform: translateX(calc(100% + 24px)); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
}
@keyframes toastSlideOut {
  from { transform: translateX(0); opacity: 1; }
  to { transform: translateX(calc(100% + 24px)); opacity: 0; }
}
[data-sonner-toast] { animation: toastSlideIn 0.35s cubic-bezier(0.16, 1, 0.3, 1) both; }
div[role="status"][data-testid] { animation: toastSlideIn 0.35s cubic-bezier(0.16, 1, 0.3, 1) both !important; }
`;

function App() {
  useEffect(() => {
    initGlobalErrorHandlers();
  }, []);

  return (
    <>
      <style>{TOAST_STYLES}</style>
      <Routes />
      <Toaster
        position="top-right"
        containerStyle={{ top: 16, right: 16 }}
        toastOptions={{
          duration: 4000,
          style: {
            background: "#18181b",
            color: "#f4f4f5",
            fontSize: "13px",
            fontWeight: 500,
            borderRadius: "10px",
            padding: "12px 16px",
            border: "1px solid rgba(255,255,255,0.06)",
            boxShadow: "0 8px 30px rgba(0,0,0,0.25), 0 0 0 1px rgba(0,0,0,0.1)",
            maxWidth: "380px",
            animation: "toastSlideIn 0.35s cubic-bezier(0.16, 1, 0.3, 1) both",
          },
          success: {
            iconTheme: { primary: "#10b981", secondary: "#18181b" },
          },
          error: {
            iconTheme: { primary: "#ef4444", secondary: "#18181b" },
          },
        }}
      />
    </>
  );
}

export default App;
